import { render } from "./Campanas.vue?vue&type=template&id=ece14174&scoped=true"
import script from "./Campanas.vue?vue&type=script&lang=js"
export * from "./Campanas.vue?vue&type=script&lang=js"

import "./Campanas.vue?vue&type=style&index=0&id=ece14174&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ece14174"]])

export default __exports__